// extracted by mini-css-extract-plugin
module.exports = {"MonitorAIUsage":"MonitorAIUsage_MonitorAIUsage__2ZYPx","Panel":"MonitorAIUsage_Panel__1ZFar"};